<template>
  <!-- Toast notifications will be handled by SweetAlert2 -->
</template>

<script setup lang="ts">
import { useToast } from '~/composables/useToast'

const { showToast } = useToast()

// Expose the showToast function to be used globally
defineExpose({
  showToast
})
</script>

<style scoped>
 
</style>
  